// LESSEEPORT-1593: helpers for handling the backend's "Method Already Default"
// no-op response on PUT /recurringPayments/{account}/paymentMethod.
// The operation is a no-op, not a failure — same pattern as the LESSEEPORT-1583
// autopay no-op fix.

const METHOD_ALREADY_DEFAULT_MESSAGE = 'method already default';

/**
 * True when the error is the backend's 400 "Method Already Default" no-op
 * response. The method is already the default, so the caller should treat
 * this as success, not as an error.
 */
export function isMethodAlreadyDefaultError(error) {
    if (error?.response?.status !== 400) {
        return false;
    }
    const data = error.response.data;
    const message = typeof data === 'string' ? data : data?.Message || data?.message || '';
    return message.trim().toLowerCase() === METHOD_ALREADY_DEFAULT_MESSAGE;
}

/**
 * Guard for the post-add "Make Default" flow: only send the set-as-default PUT
 * when the user asked for it AND the freshly fetched method is not already the
 * default (the backend auto-promotes the first/only method on add).
 */
export function shouldSendSetAsDefaultPut(paymentMethodFullData, pendingTokenContext) {
    return Boolean(
        paymentMethodFullData &&
        pendingTokenContext?.shouldSetAsDefault &&
        paymentMethodFullData.IsDefault !== true
    );
}
